export default __webpack_public_path__ + "static/media/pic2.ac8fa8b6.jpg";